import React, { useEffect, useState } from 'react'
import SimpleModal from './SimpleModal'
import { Progress, Button, Form, Spin, Input, Steps, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux'
import { DataGetAction, DataRequestAction } from 'redux/actions/http'


import RadioButtons from '../Questions/RadioButtons'
import Checkboxes from '../Questions/Checkboxes'
const { Step } = Steps;
const DailyActivity = () => {

    const dailyUpdatesProps = useSelector(state => state.dailyUpdate)
    const { showDailyActivityUpdateModal, initialValue, dailyQuestion, showInitialValue, saveDailyUpdateLoader, showSuccessMessage, redFlags, apiMessage, saveDailyUpdate } = dailyUpdatesProps
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const { role } = userInfo

    const dispatch = useDispatch();
    const [current, setCurrent] = useState(0);
    const [currentStep, setCurrentStep] = useState(0);
    const [currentStage, setCurrentStage] = useState('dailyQuestion');

    const [parentOfQuestion, setParentOfSubQuestion] = useState(-1);

    const [subQuestion, setShowSubQuestion] = useState(null);
    console.log(parentOfQuestion, subQuestion)
    const [surveyResult, setSurvey] = useState({ "dailyQuestion": dailyQuestion && dailyQuestion.length ? dailyQuestion : [], "redFlags": redFlags && redFlags.length ? redFlags : [] });
    const [form] = Form.useForm();





    const setDailyActivityQuestion = () => {
        if (showDailyActivityUpdateModal) {
            if (showInitialValue && initialValue) {
                let obj = { "dailyQuestion": initialValue.dailyUpdate, "redFlags": initialValue.redFlags };
                setSurvey({ ...obj })
            }

        }
    }

    useEffect(setDailyActivityQuestion, [showDailyActivityUpdateModal])

    const fetchDailyActivityQuestion = () => {
        if (role === 'client' && !showInitialValue) {
            dispatch(DataGetAction('getPatientDailyActivityQuestion', '', 'fetchingQuestion'))
        }

    }
    useEffect(fetchDailyActivityQuestion, [showInitialValue])

    const renderSingleQuestion = (data) => {
        console.log("====== data =====", JSON.stringify(data));
            if (data.questionType === "Radio") {
                return <RadioButtons data={data} showInitialValue={showInitialValue} />
            } else if (data.questionType === "Checkbox" || data.questionType === "CheckBox") {
                return <Checkboxes data={data} showInitialValue={showInitialValue} />
            } else if (data.questionType === "textBox") {
            }
        
    }

    const renderQuestions = () => {
        if (currentStage !== 'filledBy' && surveyResult && surveyResult[currentStage] && surveyResult[currentStage].length && current <= surveyResult[currentStage].length - 1) {
            console.log('=======data===========', surveyResult['redFlags'])
            return renderSingleQuestion(surveyResult[currentStage][current])
        } else if (currentStage === 'filledBy') {
            return <div>
                <h2>Filled by</h2>
                <div className="gx-px-3 gx-mt-2">
                    <Form.Item name="recordAddBy"
                        rules={[{ required: true, message: 'Please input your name!' }]}
                        initialValue={initialValue && initialValue.filledBy}
                    >
                        <Input disabled={initialValue && initialValue.filledBy ? true : false} />
                    </Form.Item>
                </div>
            </div>
        }
    }

    const completeForm = () => {
        form.validateFields().then(data => {
            setCurrent(0);
            setShowSubQuestion(null);
            setParentOfSubQuestion(-1)

            dispatch(DataRequestAction('POST', 'saveDailyUpdate', { dailyUpdate: surveyResult.dailyQuestion, redFlags: surveyResult.redFlags, recordAddBy: data.recordAddBy }, '', 'savingDailyUpdateData'));

        }).catch(error => {
            console.log("========== error ======", error)
        })
    }


    const next = () => {
        form.validateFields().then(data => {
            let selectedValue = Object.values(data);
            if (surveyResult[currentStage][current].questionType === "Checkbox" || surveyResult[currentStage][current].questionType === "CheckBox") {
                selectedValue = selectedValue[0];
            }

            surveyResult[currentStage][current]['selected'] = selectedValue
            setSurvey({ ...surveyResult });


            setCurrent(current + 1);



        }).catch(error => {
            console.log("========== error ======", error)
        })
    };




    const nextStep = () => {
        form.validateFields().then(data => {



            let selectedValue = Object.values(data)
            if (surveyResult[currentStage][current].questionType === "Checkbox" || surveyResult[currentStage][current].questionType === "CheckBox") {
                selectedValue = selectedValue[0];
            }



            surveyResult[currentStage][current]['selected'] = selectedValue
            setSurvey({ ...surveyResult });

            if (currentStage === 'dailyQuestion') {
                setCurrentStage("redFlags");
            } else {
                setCurrentStage('filledBy');
            }

            setCurrentStep(currentStep + 1);
            setCurrent(0);





        }).catch(error => {
            console.log("========== error ======", error)
        })


    }

    const prev = () => {
        setCurrent(current - 1);
    };

    const closeModal = () => {
        setCurrent(0)
        setCurrentStep(0)
        setCurrentStage('dailyQuestion')


    }
    const closeModalAndHide = () => {
        setCurrent(0)
        setCurrentStep(0)
        setCurrentStage('dailyQuestion')
        dispatch({
            type: 'show_daily_activity_update_modal',
            showInitialValue: false,
            payload: null
        })
    }

    if (saveDailyUpdate) {
        setCurrent(0)
        setCurrentStep(0)
        setCurrentStage('dailyQuestion')
        dispatch(DataGetAction('getPatientInfo', '', 'gettingPatientInfo'))
        if (showSuccessMessage) {
            message.success(apiMessage)
        }
        else {
            message.info(apiMessage)
        }
        dispatch({
            type: 'resetDailyUpdate'
        })
    }


    const steps = [
        {
            title: 'Daily Question',
            content: renderQuestions(),
        },
        {
            title: 'Red Flags',
            content: renderQuestions(),
        },
        {
            title: 'Filled By',
            content: renderQuestions(),
        },
    ];
    // let length = surveyResult[currentStep]



    return (
        <SimpleModal
            title="Questionnaire"
            modalFor="show_daily_activity_update_modal"
            visible={showDailyActivityUpdateModal}
            width={630}
            maskClosable={false}
            closeFn={() => closeModal()}
            closable={true}
            className="questionnaire-modal"
            style={{ top: 20 }}
        >
            <div className="gx-p-3">
                <Form
                    name="basic"
                    form={form}

                >
                    <Steps current={currentStep} size="small" progressDot >
                        {steps.map(item => (
                            <Step key={item.title} title={item.title} />
                        ))}
                    </Steps>
                    <div className="steps-content">{steps[currentStep].content}</div>
                    <div className="footer gx-d-flex">
                        {currentStage !== 'filledBy' &&

                            <Progress percent={((current / (surveyResult && surveyResult[currentStage].length + 1)) * 100).toFixed(0)} size="small" />
                        }
                        <div className="buttons">
                            <div className="steps-action reverse-btns">
                                {currentStage !== "filledBy" && current < surveyResult[currentStage].length - 1 && (
                                    <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => next()}>
                                        Next
                                    </Button>
                                )}
                                {currentStage !== "filledBy" && (current === surveyResult[currentStage].length - 1) && (
                                    <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => nextStep()}>
                                        Next
                                    </Button>
                                )}

                                {currentStage === "filledBy" && (
                                    !saveDailyUpdateLoader ? initialValue && initialValue.filledBy ? <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => closeModalAndHide()}>
                                        Close
                                    </Button> : <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => completeForm()}>
                                        Done
                                    </Button> :
                                        <Spin size="small" color="blue"><Button className="gx-pt-0 gx-mb-0" type="primary" disabled>
                                            Done
                                        </Button></Spin>
                                )}
                                {current > 0 && (
                                    <Button className="gx-pt-0 gx-mb-0" style={{ margin: '0 8px' }} onClick={() => prev()}>
                                        Previous
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </SimpleModal>
    )
}

export default DailyActivity
